(function () {
    'use strict';

    angular.module('app').filter('notSelected', function () {
        return function (items) {
            var filtered = [];
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                if (!item.selected) {
                    filtered.push(item);
                }
            }
            return filtered;
        };
    });

    angular
        .module('app')
        .controller('multifieldsearch', multifieldsearch);

    multifieldsearch.$inject = ['$rootScope', '$scope', '$uibModalInstance', 'columnFactory', 'searchService', '$filter', '$q'];

    function multifieldsearch($rootScope, $scope, $modalInstance, columnFactory, searchService, $filter, $q) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'advancedsearch';
        vm.modalInstance = $modalInstance;
        vm.selectedItems = [];
        //adds a search group object to the array, this will be used as the model and is also used to repeat the number of search groups.
        vm.searchGroups = [{ value: '', field: '' }];
        vm.availableColumns = [];
        vm.searchFieldSelected = {};

        //remove search criteria elements
        vm.resetSearchCriteria = function (group) {
            vm.searchGroups = [{ index: 0, value: '', field: '' }];
            vm.searchCriteriaChanged();
        };

        //removes a search group from the list, takes index as a parameter.
        vm.removeSearchGroup = function (index) {
            vm.searchGroups.splice(index, 1);
            vm.availableColumns.splice(index, 1);
            vm.searchCriteriaChanged();
        };

        //add search criteria elements
        vm.addSearchGroup = function () {
            vm.searchGroups.push({ value: '', field: '' });
            vm.availableColumns.push(angular.copy(columnFactory.availableColumns));
            vm.searchCriteriaChanged();
        };

        // used to keep track of when to show the add search group button 
        vm.showAddGroupButton = function (index) {
            var val = (index === 0) ? true : false;
            return val;
        };

        //used to control wether the remove button should be displayed or not
        vm.showRemoveGroupButton = function (group) {
            var val = (group.index === vm.searchGroups.length - 1) ? true : false;
            return val;
        };

        vm.getAvailableColumns = function () {
            //check the factory first and get the fields, otherwise have it make a call to the server
            var deferred = $q.defer();
            if (columnFactory.availableColumns.length > 0) {
                deferred.resolve(columnFactory.availableColumns);
                //vm.availableColumns = angular.copy(columnFactory.availableColumns);
            }
            else {
                columnFactory.getAvailableColumns().success(function (response) {
                    var columns = [];
                    deferred.resolve(columnFactory.availableColumns);
                    //vm.availableColumns = angular.copy(columnFactory.availableColumns);
                });
            };
            return deferred.promise;
        }


        //indicates if a search can be performed
        vm.searchButtonDisabled = true;

        vm.searchCriteriaChanged = function () {
            vm.searchButtonDisabled = false;
            //iterate over the search groups and check the values.
            angular.forEach(vm.searchGroups, function (item, index) {
                if (item.value == '' || item.field == '') {
                    vm.searchButtonDisabled = true;
                }
            });
        };

        //search call, iterates over the groups and constructs the parameters.
        vm.search = function () {
            //sanity check
            if (!vm.searchButtonDisabled) {
                var searchCriteria = [];
                angular.forEach(vm.searchGroups, function (item, index) {
                    searchCriteria.push(
                    {
                        "schemaID": item.field,
                        "valueStr": item.value,
                        "startDate": "",
                        "endDate": "",
                        "searchOp": 0
                    })

                });

                $modalInstance.close(searchCriteria);
            }
            
        };
    }
})();
